<div class="row">
    <div class="col-12">
      <ngx-loading [show]="loadingIndicator" ></ngx-loading>
      
      <div class="form">
        <label for="form-search"></label>
        <input type="text" [(ngModel)]="entries" id="form-search" placeholder=" ">
        <button [disabled]="!entries" (click)="onClick()">Search</button><br/>
        <i class="fa fa-lg fa-spinner fa-spin" *ngIf="spinner == true"></i>
      <div>
          <div style="text-align:left" *ngFor= "let entries of displayItems | filter: entries   | paginate: { itemsPerPage: 10, currentPage: p }  " >
            <h3><a href="{{upURL}}/{{entries.route}}" style="color:darkblue;"> {{entries.title}}</a></h3>
            <a href="{{upURL}}/{{entries.route}}" style="color:green; text-decoration:none" class="search-link"> {{upURL}}/{{entries.route}}</a><br/>
            <span style="font-size:18px;">  {{entries.subtitle}}</span><br/>
            <span>{{entries.description}}</span><br/><br/>
          </div>           
          <div><pagination-controls autoHide="true" (pageChange)="p= $event"></pagination-controls></div>
        </div>
      </div>
    </div>
  </div>   